// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aDL7","content":"styles_content__2VyZY"};